module.exports = __webpack_public_path__ + "static/media/extraccion.f5be3152.svg";